/**************************************************************************************************/
/*   File: /src/app/stores/effects/router/effects.ts                                              */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed Apr 17 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { map, tap } from 'rxjs/operators';

import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';

import * as fromActions from '../../actions';

/**
 * The router effect
 */
@Injectable()
export class RouterEffects {

  /**
   * The navigate effect
   */
  @Effect({ dispatch: false })
  navigate$ = this.actions$.pipe(
    ofType(fromActions.fromRouter.RouterActionTypes.Go),
    map((action: fromActions.fromRouter.Go) => action.payload),
    tap(({ path, query: queryParams, extras }) =>
      this.router.navigate(path, { queryParams, ...extras }),
    )
  );

  /**
   * The navigate back effect
   */
  @Effect({ dispatch: false })
  navigateBack$ = this.actions$.pipe(
    ofType(fromActions.fromRouter.RouterActionTypes.Back),
    tap(() => this.location.back())
  );

  /**
   * The forward
   */
  @Effect({ dispatch: false })
  navigateForward$ = this.actions$.pipe(
    ofType(fromActions.fromRouter.RouterActionTypes.Forward),
    tap(() => this.location.forward())
  );

  /**
   * The contructor
   * @param actions$ The actions
   * @param router The router
   * @param location The location
   */
  constructor(
    private actions$: Actions,
    private router: Router,
    private location: Location
  ) {}
}
